<template>
  <span v-if="isInfinity" class="icon icon-infinity icon_inherit"></span>
  <span v-else-if="isDash">—</span>
  <span v-else-if="isDone">{{ doneTrainingDuration }}</span>
  <duration-with-unit
    v-else
    v-model="duration.value"
    :durationUnit="duration.unit"
    :is-readonly="true"
  ></duration-with-unit>
</template>

<script>
import { trainingDate } from '@/mixins/training-date'
import { status } from '@/main.config'
import timeString from '@/modules/time-string'
import DurationWithUnit from '@/components/DurationWithUnit.vue'

export default {
  name: 'TrainingDuration',
  mixins: [trainingDate],
  components: {
    DurationWithUnit
  },
  props: {
    training: {
      type: Object,
      required: true
    },
    from: {
      type: Boolean,
      required: false
    }
  },
  computed: {
    isInfinity() {
      return this.training.status === status.plan && this.training.duration === null
    },
    isDash() {
      if (this.training.status === status.done) {
        if (this.training.date_start && this.training.date_end) return false
        else return true
      } else return this.training.status === status.missed || !this.training.duration
    },
    isDone() {
      return this.training.status === status.done
    },
    doneTrainingDuration() {
      if (!this.isDone) {
        return null
      }
      const duration = this.getDoneTrainingDuration(this.training)
      if (this.from) {
        return duration > 0
          ? `${Math.floor(duration / 60)} ${this.$t('general.outOf')}  ${timeString(
              this.training.duration * 60,
              false,
              true
            )}`
          : '—'
      }
      return duration > 0 ? timeString(duration, false, true) : '—'
    },
    duration() {
      return this.getDurationWithUnit(this.training.duration, this.training.course_training_duration_unit)
    }
  }
}
</script>
